import { atom } from 'jotai';

import { FreightLaneFormState } from '~/modules/transportation/types';

const initialState: FreightLaneFormState = {
  carrierId: '',
  transportationMode: 'TRUCK',
  originLocationId: '',
  originLocationType: '',
  freightLaneRouteId: '',
  routeLocationAId: '',
  routeLocationAType: '',
  routeLocationBId: '',
  routeLocationBType: '',
  destinationCity: '',
  destinationState: '',
  destinationZipCode: '',
  destinationCountry: '',
  active: true,
  notes: '',
};

export const $freightLaneForm = atom<FreightLaneFormState>(initialState);

export const $resetFreightLaneForm = atom(null, (get, set) => {
  set($freightLaneForm, initialState);
});

export const $updateFreightLaneForm = atom(
  null,
  (get, set, update: Partial<FreightLaneFormState>) => {
    const currentState = get($freightLaneForm);
    set($freightLaneForm, { ...currentState, ...update });
  },
);
